// Financial Analysis tab content. Thin wrapper
// around the shared <AnalystTabContent lane="A2" /> shell.
import type { DealDetailDto } from "@/types/deals";
import { AnalystTabContent } from "./AnalystTabContent";

interface FinancialAnalysisTabContentProps {
  deal: DealDetailDto;
}

export function FinancialAnalysisTabContent({
  deal,
}: FinancialAnalysisTabContentProps) {
  return <AnalystTabContent deal={deal} lane="A2" />;
}
